import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import Loading from './Loading';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as charts from '../../library/charts';
import * as util from '../../library/utilitys';

ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    ChartDataLabels
);

class DashboardBarChartHorizontal extends Component {
    render() {
        const { title = 'Chart', types, chartData = {}, icon, legend = true, position = 'top', align = 'end', unit = 'คน' } = this.props;

        const labels = chartData.labels || [];
        const data = (chartData.datasets?.[0]?.data) || [];
        const total = data.reduce((sum, value) => sum + value, 0);

        const dataset = {
            labels,
            datasets: [
                {
                    ...chartData.datasets[0],
                    backgroundColor: charts.getChartColors(labels.length),
                    datalabels: {
                        color: 'white',
                        anchor: 'start',
                        align: 'end',
                        formatter: value => util.formatNumber(value),
                        font: { size: 10 }
                    }
                }
            ]
        };

        const options = {
            indexAxis: 'y',
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
                legend: {
                    display: legend,
                    position: position,
                    align: align,
                    labels: {
                        boxWidth: 12,
                        padding: 16
                    }
                },
                tooltip: {
                    callbacks: {
                        label: (context) => {
                            const value = context.raw;
                            const label = context.label || '';
                            const percentage = ((value / total) * 100).toFixed(1);
                            return `${label}: ${util.formatNumber(value)} ${unit} (${percentage}%)`;
                        }
                    }
                },
                datalabels: {
                    display: true
                }
            },
            scales: {
                x: {
                    beginAtZero: true,
                    ticks: {
                        display: false
                    },
                    grid: {
                        display: false
                    }
                },
                y: {
                    grid: {
                        display: false
                    }
                }
            }
        };

        return (
            <Card className="card-border mb-0 h-100">
                <Card.Header className="card-header-action bg-primary">
                    <h6 className="text-white">{icon && <i className={`${icon} me-2`}></i>}{title}</h6>
                </Card.Header>
                <Card.Body style={{ maxHeight: '350px', position: 'relative' }}>
                    <div style={{ height: '100%', minHeight: '300px' }}>
                    {(labels.length > 0 && data.length > 0) ? (
                        <Bar
                            data={dataset}
                            options={options}
                            plugins={[ChartDataLabels]}
                        />
                    ) : (
                        <Loading height="300px" variant="primary" />
                    )}
                    </div>
                </Card.Body>
            </Card>
        );
    }
}

export default DashboardBarChartHorizontal;
